<template>
     <div class="animation">
        <div class="spinner animate__zoomIn"></div>
     </div>
</template>
<script>

export default {
    name:'Loading',
    props:{
        show: {
                type:Boolean,
                default: () => false,
                // default:true
            }
    },
    data() {
    return {
        showLoading:'',
    };
  },
    mounted() {
      // 获取动画
      var _this = this;
      _this.showLoading = _this.show
      console.log(this.showLoading,this.show,'jiazai');
    //   setTimeout(() => {
    //     loader.style.display = "none";
    //   },2000)
        // 加载完成事件
        // window.onload = function () {
        //     // 加载完成，隐藏动画，显示内容
        //     loader.style.display = "none";
        // }
  },
  watch:{
	show(newValue, oldValue) {
        let loader = document.querySelector(".animation");
        if(newValue == true) {
            loader.style.display = "none";
        }
	}
}
 
}
</script>
<style>
.spinner {
    width: 60px;
    height: 60px;
    border: 5px solid #FFF;
    border-bottom-color: #FF3D00;
    border-radius: 50%;
    display: inline-block;
    -webkit-animation: rotation 1s linear infinite;
    animation: rotation 1s linear infinite;
}
 @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
    .animation {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 9999;
        width: 100%;
        min-height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #222c32;
    }
 /* .spinner {
            --size: 30px;
            --first-block-clr: #005bba;
            --second-block-clr: #fed500;
            --clr: #111;
        }

        .spinner::after,
        .spinner::before {
            box-sizing: border-box;
            position: absolute;
            content: "";
            width: var(--size);
            height: var(--size);
            top: 50%;
            animation: up 2.4s cubic-bezier(0, 0, 0.24, 1.21) infinite;
            left: 50%;
            background: var(--first-block-clr);
        }

        .spinner::after {
            background: var(--second-block-clr);
            top: calc(50% - var(--size));
            left: calc(50% - var(--size));
            animation: down 2.4s cubic-bezier(0, 0, 0.24, 1.21) infinite;
        }

        @keyframes down {

            0%,
            100% {
                transform: none;
            }

            25% {
                transform: translateX(100%);
            }

            50% {
                transform: translateX(100%) translateY(100%);
            }

            75% {
                transform: translateY(100%);
            }
        }

        @keyframes up {

            0%,
            100% {
                transform: none;
            }

            25% {
                transform: translateX(-100%);
            }

            50% {
                transform: translateX(-100%) translateY(-100%);
            }

            75% {
                transform: translateY(-100%);
            }
        } */
</style>



// WEBPACK FOOTER //
// src/components/animation.vue